export class StockInObj{
    reportedDate:string;
    anticipated:number;
    saleorder:number;
    dummy:number;
    superDummy:number;
}
